<template>
    <div class="forminput w-full ">

      <div class="input-holder mb-3">
                  <select
                    name="banks"
                    id="banks"
                    class="form-select"
                    @change="updateBonus()" 
                    v-model="isBonus"
                  >
                    <option :value="true">รับโปรโมชั่น</option>
                    <option  :value="false"
                      >ไม่รับโปรโมชั่น</option
                    >
                  </select>
                </div>
 
     

     
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { UserInfoMixins } from "@/mixins/UserInfo.js";
import { PrefixMixins } from "@/mixins/Prefix.js";
import { BankMixins } from "@/mixins/BankService.js";
import { updateBonus } from "@/services/modules/promotion.js";

export default {
  name: "UpdateBonus",
  mixins: [UserInfoMixins, PrefixMixins, BankMixins],

  data() {
    return {
      isBonus: false,
    };
  },
  computed: {
    ...mapGetters([
      "getError",
      "getLoading",
      "getLineId",
      "getGameList",
      "getPromotion",
      "getPrefix",
    ]),
  },

  watch: {
    UserInfo(newValue, oldValue) {
      console.log("UserInfo");
      console.log(newValue.BonusInfo);
      this.isBonus = newValue.BonusInfo.isBonus;
    },

    isBonus(newValue, oldValue) {
      this.isBonus = value;
    },

  },
  methods: {
    ...mapActions(["checkAuth", "userSignOut"]),
    async reload() {
      await this.checkAuth();
      location.reload();

    },
    async updateBonus(value) {
      await updateBonus(this.$swal, this.isBonus, async (res) => {
        if (res.status) {
          this.reload()
          console.log(value);    
          this.$swal.fire("อัพเดทสภานะโปรโมชั่นเรียบร้อยแล้ว", "", "success");
        } else {
          this.reload()
        }
      });
    },
  },
  async mounted() {},
};
</script>
<style scoped>
.form-check-inline{
  display: inline;
}
.msg {
        background: #e91e63;
        color: #FFFFFF;
        padding: 8px 15px;
        margin-bottom: 8px;
        display: none;
        border-radius: 10px;
    }
    .boxStep:not(#boxStep1){ display: none;}
    .box-backtohome{ position: absolute; right: 20px; color: var(--cl-white); font-size: 20px;top: 20px;}
    .app__body{
        min-height: 100vh;
    }

    .samhokha-login__bg-main input {
    background-color: var(--main-bg2);
    border-radius: 0.375rem;
    box-sizing: border-box;
    padding: 15px 15px 15px 15px;
    width: 100%;
}

    .form-select{
        background-color: rgb(59 70 78);
        border-radius: 0.375rem;
        box-sizing: border-box;
        padding: 15px 15px 15px 20px;
        width: 100%;
    }
    #boxStep1 .Icon-inside span{
        position: relative;
        top: 0;
        right: 0;
        background-color: var(--main-bg2);
        border-radius: 0.375rem;
        box-sizing: border-box;
        margin-top: 5px;
        border: 0;
        padding-top: 3px;
        padding-bottom: 5px;
        width: 100% !important;
    }
    .select2-container--bootstrap-5 .select2-selection--single .select2-selection__rendered{
        color: var(--cl-while);
    }
                .se_email{ display: none;}
        .select_type label{ cursor: pointer;}
    
    .select_type {
        margin-top: 15px;
        display: flex;
        overflow: hidden;
    }

    .select_type input {
        position: absolute !important;
        clip: rect(0, 0, 0, 0);
        height: 1px;
        width: 1px;
        border: 0;
        overflow: hidden;
    }

    .select_type label {
        background-color: var(--main-bg2);
        color: var(--cl-gray);
        line-height: 1;
        text-align: center;
        padding: 8px 20px;
        margin-right: -1px;
        border: 1px solid rgba(0, 0, 0, 0.2);
        transition: all 0.1s ease-in-out;
    }

    .select_type label:hover {
        cursor: pointer;
    }

    .select_type .active{
        background-color: var(--cl-yelow);
        color: var(--cl-white);
        box-shadow: none;
    }

    .select_type label:first-of-type {
        border-radius: 4px 0 0 4px;
    }

    .select_type label:last-of-type {
        border-radius: 0 4px 4px 0;
    }

    .bank_flex .bank_box .-check-right{
        bottom: -5px;
        right: 45px;
        height: 45px;
    }
    .bank_flex i{
        left: 0px;
        padding: 10px;
        top: 0px;
    }
    .boxinp i {
        left: 0px !important;
        top: 0px !important;
        padding: 0px !important;
    }
    .Icon-inside i.fa-square-chevron-right, .Icon-inside i.fa-floppy-disk-circle-arrow-right, .Icon-inside i.fa-xmark{ position:relative !important; top: 0px !important;  left: 0px !important; padding :5px !important; }
    #confirmbank{ display: none;}
 
    .anav-menu{
        text-align: center;
        color: #dfba36;
        cursor: pointer;
        height: 1.5rem;
        margin-bottom: 0.5rem;
        font-size: 1.3rem;
    }
    .anav-i{
        font-size: 2rem;
        color: #dfba36;
    }
    .closebtn i{font-size:1.3rem;}
</style>



// WEBPACK FOOTER //
// src/components/form/UpdateBonus.vue